import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp32};
`

export const ListCardContainer = styled.div`
  > div {
    border-top-right-radius: 0;
    border-top-left-radius: 0;
  }
`

export const OrdersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  border-bottom: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  padding-bottom: ${props => props.theme.spacing.sp16};
  padding-top: ${props => props.theme.spacing.sp16};
`

export const PaginationContainer = styled.div`
  margin-top: ${props => props.theme.spacing.sp16};
  display: flex;
  justify-content: space-between;
`
